import {
  CreateUpdateVisitRegistrationDto,
  DefaultApi,
  GetAppointmentChannelDto,
  GetVisitRegistrationCalendarSlotDto,
  GetVisitRegistrationDto,
} from '../autogenerated/spdApiClient';
import { GridRecord } from '../../components/Grid/GridDataTypes';
import { externalVisitBookingForGrid } from '../../../spd/components/ExternalVisitBooking/ExternalVisitBookingSearch';

export interface ExternalVisitBookingContextInterface {
  get: (id: string) => Promise<GetVisitRegistrationDto>;
  getCalendar: (
    dateStart?: Date,
    dateEnd?: Date,
    healthcareId?: string,
  ) => Promise<GetVisitRegistrationCalendarSlotDto[]>;
  getAppointmentChannels: (
    healthcareId?: string,
  ) => Promise<GetAppointmentChannelDto[]>;
  getAllByPortion: (
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    filterColumns?: string,
  ) => Promise<GridRecord[]>;
  getAllCount: (filterText?: string, filterColumns?: string) => Promise<number>;
  createBooking: (
    dto: CreateUpdateVisitRegistrationDto,
  ) => Promise<GetVisitRegistrationDto>;
  updateBooking: (
    id: string,
    dto: CreateUpdateVisitRegistrationDto,
  ) => Promise<GetVisitRegistrationDto>;
}

export const ExternalVisitBookingContext = (
  api: DefaultApi,
): ExternalVisitBookingContextInterface => {
  return {
    get: (id: string) => api.visitRegistrationControllerGetExternalBooking(id),

    getCalendar: (dateStart?: Date, dateEnd?: Date, healthcareId?: string) =>
      api.visitRegistrationControllerGetExternalBookingCalendar(
        dateStart,
        dateEnd,
        healthcareId,
      ),

    getAppointmentChannels: (healthcareId?: string) =>
      api.visitRegistrationControllerGetMyAppointmentChannels(healthcareId),

    getAllByPortion: async (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      filterColumns?: string,
    ) => {
      const data =
        await api.visitRegistrationControllerGetExternalBookingByPortion(
          pageSize,
          pageNumber,
          orderBy || '',
          orderDirection || '',
          filterText || '',
          filterColumns || '',
        );
      return data.map(externalVisitBookingForGrid);
    },

    getAllCount: (filterText?: string, filterColumns?: string) =>
      api.visitRegistrationControllerGetExternalBookingCount(
        filterText || '',
        filterColumns || '',
      ),

    createBooking: (dto: CreateUpdateVisitRegistrationDto) =>
      api.visitRegistrationControllerCreateExternalBooking(dto),

    updateBooking: (id: string, dto: CreateUpdateVisitRegistrationDto) =>
      api.visitRegistrationControllerUpdateExternalBooking(id, dto),
  };
};
